import { ref, reactive } from 'vue';
import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, createVNode as _createVNode } from "vue";
import { message } from "ant-design-vue";
import { addNewCountry } from "@/api/payManage/googleTax";
import { useGoogleTaxManage } from "./useGoogleTaxManage";
export default /*#__PURE__*/_defineComponent({
  __name: 'AddNewCountryModel',
  props: {
    open: {
      type: Boolean
    }
  },
  emits: ["handleCloseModel"],
  setup(__props, {
    expose,
    emit
  }) {
    const formRef = ref(null);
    const formData = reactive({
      countryInf: "",
      iosCode: "",
      currency: "",
      taxRate: 0
    });
    const rules = {
      countryInf: [{
        required: true,
        message: "请输入国家"
      }],
      currency: [{
        required: true
      }, {
        validator: (rule, value) => {
          if (!value) return Promise.resolve();
          const upperCasePattern = /^[A-Z]+$/;
          if (!upperCasePattern.test(value)) {
            return Promise.reject("币种只能输入英文大写字母");
          }
          return Promise.resolve();
        }
      }],
      taxRate: [{
        required: true,
        message: "请输入税率"
      }]
    };
    const {
      countryInfo,
      filterOption
    } = useGoogleTaxManage();
    const handleOk = () => {
      formRef.value.validate().then(() => {
        addNewCountry({
          payChnl: "google",
          country: formData.countryInf,
          regionCode: formData.iosCode,
          currency: formData.currency,
          taxRate: String(formData.taxRate)
        }).then(res => {
          if (res.code === "0") {
            message.success("新建成功");
            emit("handleCloseModel");
          }
        });
      });
    };
    const resetData = () => {
      formData.countryInf = "";
      formData.iosCode = "";
      formData.currency = "";
      formData.taxRate = 0;
    };
    const handleCancel = () => {
      resetData();
      emit("handleCloseModel");
    };
    const handleChangeCountry = (value, option) => {
      if (value) {
        formData.iosCode = option.key;
      } else {
        formData.iosCode = "";
      }
    };
    expose({
      resetData
    });
    return (_ctx, _cache) => {
      const _component_a_select_option = _resolveComponent("a-select-option");
      const _component_a_select = _resolveComponent("a-select");
      const _component_a_form_item = _resolveComponent("a-form-item");
      const _component_a_input = _resolveComponent("a-input");
      const _component_a_input_number = _resolveComponent("a-input-number");
      const _component_a_form = _resolveComponent("a-form");
      const _component_a_modal = _resolveComponent("a-modal");
      return _openBlock(), _createBlock(_component_a_modal, {
        open: __props.open,
        title: "新增国家",
        onOk: handleOk,
        onCancel: handleCancel,
        destroyOnClose: true,
        maskClosable: false
      }, {
        default: _withCtx(() => [_createVNode(_component_a_form, {
          model: formData,
          "label-col": {
            span: 4
          },
          "wrapper-col": {
            span: 14
          },
          style: {
            "margin-top": "25px"
          },
          rules: rules,
          ref_key: "formRef",
          ref: formRef
        }, {
          default: _withCtx(() => [_createVNode(_component_a_form_item, {
            label: "国家：",
            name: "countryInf"
          }, {
            default: _withCtx(() => [_createVNode(_component_a_select, {
              ref: "select",
              value: formData.countryInf,
              "onUpdate:value": _cache[0] || (_cache[0] = $event => formData.countryInf = $event),
              style: {
                "width": "100%"
              },
              placeholder: "请选择国家",
              "show-search": "",
              "allow-clear": "",
              "filter-option": _unref(filterOption),
              onChange: handleChangeCountry
            }, {
              default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(countryInfo), item => {
                return _openBlock(), _createBlock(_component_a_select_option, {
                  key: item.regionCode,
                  value: item.country,
                  label: item.country
                }, {
                  default: _withCtx(() => [_createTextVNode(_toDisplayString(item.country), 1)]),
                  _: 2
                }, 1032, ["value", "label"]);
              }), 128))]),
              _: 1
            }, 8, ["value", "filter-option"])]),
            _: 1
          }), _createVNode(_component_a_form_item, {
            label: "ISO码：",
            name: "iosCode"
          }, {
            default: _withCtx(() => [_createVNode(_component_a_input, {
              value: formData.iosCode,
              "onUpdate:value": _cache[1] || (_cache[1] = $event => formData.iosCode = $event),
              disabled: true
            }, null, 8, ["value"])]),
            _: 1
          }), _createVNode(_component_a_form_item, {
            label: "币种：",
            name: "currency"
          }, {
            default: _withCtx(() => [_createVNode(_component_a_input, {
              value: formData.currency,
              "onUpdate:value": _cache[2] || (_cache[2] = $event => formData.currency = $event),
              autocomplete: "off"
            }, null, 8, ["value"])]),
            _: 1
          }), _createVNode(_component_a_form_item, {
            label: "税率：",
            name: "taxRate"
          }, {
            default: _withCtx(() => [_createVNode(_component_a_input_number, {
              style: {
                "width": "100%"
              },
              value: formData.taxRate,
              "onUpdate:value": _cache[3] || (_cache[3] = $event => formData.taxRate = $event),
              min: 0,
              precision: 2,
              formatter: value => `${value}%`,
              parser: value => value.replace('%', '')
            }, null, 8, ["value", "formatter", "parser"])]),
            _: 1
          })]),
          _: 1
        }, 8, ["model"])]),
        _: 1
      }, 8, ["open"]);
    };
  }
});